import { SIDEBAR_COUNTRY_FOR_USERS } from 'config/constants';
import PromotionItem from './PromotionItem';
import { AppState } from 'state';

export default class Promotion {
	static getCountryName = promo =>
		promo.CountryShortName === SIDEBAR_COUNTRY_FOR_USERS
			? AppState.user.country.long_name
			: promo.CountryShortName;

	id = 0;
	name = '';
	promotions = null;
	isGeneric = false;

	constructor(promo) {
		this.id = promo.Id;
		this.name = Promotion.getCountryName(promo);
		this.isGeneric = promo.CountryShortName === SIDEBAR_COUNTRY_FOR_USERS;
		this.promotions = promo.Promotions.map(item => new PromotionItem(item));
	}
}



// WEBPACK FOOTER //
// ./src/api/models/Promotion.js